import React, { useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import "./CustomerTransactionTable.scss";
import DynamicTable from "../DynamicTable/DynamicTable";
import { getTableData } from "../../util/API/tableServices";
import { useSelector } from "react-redux";
import { ReverseTransaction, ReverseVoucher } from "../../util/API/customers";
import CustomAlert from "../UI/CustomAlert/CustomAlert";
import PinPad from "../PinPad/PinPad";
import CustomInputAlert from "../UI/CustomInputAlert/CustomInputAlert";

function CustomerTable(props) {
  const theme = useTheme();
  const { page, onPageChange, pageNumbers } = props;

  const handlePageClick = (event, pageNumber) => {
    onPageChange(event, pageNumber);
  };

  return (
    <Box
      sx={{
        flexShrink: 0,
        ml: 2.5,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "white",
      }}
    >
      <Box>
        <IconButton
          onClick={(event) => handlePageClick(event, page - 1)}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <>
              <KeyboardArrowLeft />
              <span className="arrowLabelStyle">Previous</span>
            </>
          )}
        </IconButton>
      </Box>
      <Box>
        {pageNumbers.map((pageNumber, index) => {
          if (pageNumbers.length <= 5) {
            return (
              <span
                key={pageNumber}
                className={`page-number ${
                  pageNumber === page ? "active-page" : ""
                }`}
                onClick={(event) => handlePageClick(event, pageNumber)}
              >
                {pageNumber + 1}
              </span>
            );
          } else if (
            index === 0 ||
            index === pageNumbers.length - 1 ||
            Math.abs(index - page) <= 1
          ) {
            return (
              <span
                key={pageNumber}
                className={`page-number ${
                  pageNumber === page ? "active-page" : ""
                }`}
                onClick={(event) => handlePageClick(event, pageNumber)}
              >
                {pageNumber + 1}
              </span>
            );
          } else if (index === 1 || index === pageNumbers.length - 2) {
            return (
              <span key={pageNumber} className="ellipsis">
                ...
              </span>
            );
          }
          return null;
        })}
      </Box>

      <Box>
        <IconButton
          onClick={(event) => handlePageClick(event, page + 1)}
          disabled={page === pageNumbers.length - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <>
              <span className="arrowLabelStyle">Next</span>
              <KeyboardArrowRight />
            </>
          )}
        </IconButton>
      </Box>
    </Box>
  );
}

export default function CustomerTransactionTable({
  filter,
  selectedExternalAccount,
  type,
  table,
  setTable,
  setCsvData,
}) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [tableData, setTableData] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  let pageNumbers = Array.from({ length: pageCount }, (_, index) => index);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const [alert, setAlert] = useState({
    showAlert: false,
    message: "",
    severity: "",
    header: "",
  });
  const [confirmAlert, setConfirmAlert] = useState({
    showAlert: false,
    message: "",
    severity: "",
    header: "",
  });
  const [showInputAlert, setShowInputAlert] = useState({
    showAlert: false,
    severity: "",
    header: "",
    message: "",
    onConfirm: null,
    alertType: "",
    inputLabel:""
  });
  const [showPinPad, setShowPinPad] = useState(false);
  const [reverseParams, setReverseParams] = useState(null);
  const [loading, setLoading] = useState(false);

  let pin = sessionStorage.getItem("pin");
  const selectedUser = useSelector((state) => state.usersList.selectedUser);
  let agent = JSON.parse(sessionStorage.getItem("user")).payload.body;
  let isAdmin = sessionStorage.getItem("isAdmin");
  let isLoanAdmin = sessionStorage.getItem("isLoanAdmin");
  let isSuperAdmin = sessionStorage.getItem("isSuperAdmin");
  let isAssociateAdmin = sessionStorage.getItem("isAssociateAdmin");
  let configVariables = useSelector((state) => state.config.baseConfig);

  useEffect(() => {
    async function getTable() {
      if (!selectedExternalAccount && type !== "voucherHistory") return;
      let response = await fetch(`/tables/${type}.json`);
      const tableJSON = await response.json();
      setTable(tableJSON);
      setRowsPerPage(tableJSON.rowsPerPage);
      console.log(selectedExternalAccount)

      try {
        setLoading(true);

        const tableData = await getTableData(tableJSON.services, {
          userid: selectedUser.User.id,
          userpi: selectedExternalAccount?.split("-")[0],
        });
  
        console.log(tableData)
  
        let history = [];
        if (tableData?.Status === "1") {
          history = tableData?.payload?.record;
          if (!Array.isArray(history)) {
            history = [history];
          }
        }
  
        // if (isAdmin === 'false') {
        //   history = history.filter((transaction) => {
        //     return transaction?.Vtranshistorybyuser2?.msg && !transaction?.Vtranshistorybyuser2?.msg.includes("Loan");
        //   })
        // }
  
        // Filter tableData based on filter prop
        if (filter.startDate || filter.endDate || filter.type) {
          const startDate = filter.startDate
            ? new Date(filter.startDate).setHours(0, 0, 0, 0)
            : null;
          const endDate = filter.endDate
            ? new Date(filter.endDate).setHours(0, 0, 0, 0)
            : null;
  
          const transtype = filter.type
  
          history = history.filter((item) => {
            let transTime, transType;
            if (type !== "voucherHistory") {
              transTime = new Date(item.Vtranshistorybyuser2?.transTime).setHours(0, 0, 0, 0);
              transType = item.Vtranshistorybyuser2?.transType;
            }
  
            else {
              transTime = new Date(item.Vnodetransferpool?.transferTime).setHours(0, 0, 0, 0);
              transType = item.Vnodetransferpool?.type;
            }
  
            console.log(transType, transtype)
            return (
              (!startDate || transTime >= startDate) &&
              (!endDate || transTime <= endDate) &&
              (!transtype || transType == transtype)
            );
          });
        }
  
      // history = history.map((item) => {
      //   // Case 1: nested under Vtranshistorybyuser2
      //   if (item.Vtranshistorybyuser2 && item.Vtranshistorybyuser2.msg) {
      //     item.Vtranshistorybyuser2.msg = decodeHTMLEntities(item.Vtranshistorybyuser2.msg);
      //   }
      
      //   // Case 2: flat object with msg
      //   if (item.msg) {
      //     item.msg = decodeHTMLEntities(item.msg);
      //   }
      
      //   return item;
      // }).filter((item) => {
      //   console.log("item----------", item);
      //   return item; // filter condition if any can be applied here
      // });
  
        setPageCount(Math.ceil(history.length / rowsPerPage));
        setTableData(history);
        console.log(history)
        setCsvData(history);
      } catch (error) {
        
      } finally {
        setLoading(false);
      }
      
    }
    getTable();
  }, [selectedUser.User.id, selectedExternalAccount, alert, filter]);

  // const handleConfirm = (e, enteredPin) => {
  //   let PIN = enteredPin.join("");
  //   if (reverseParams) {
  //     handleReverse(PIN, reverseParams.referenceID, reverseParams.transType, reverseParams.transID, reverseParams.reason);
  //     setShowPinPad(false);
  //     setReverseParams(null);
  //   }
  // };

  const handleConfirm = (e, enteredPin) => {
    let PIN = enteredPin.join("");
    if (reverseParams) {
      if (type === 'voucherHistory') {
        console.log("Calling voucherReverse...");
        voucherReverse(PIN, reverseParams.referenceID, reverseParams.transType, reverseParams.transID, reverseParams.reason);
      } else {
        console.log("Calling handleReverse...");
        handleReverse(PIN, reverseParams.referenceID, "80", reverseParams.transID, reverseParams.reason);
      }
      // handleReverse(PIN, reverseParams.referenceID, reverseParams.transType, reverseParams.transID, reverseParams.reason);
      setShowPinPad(false);
      setReverseParams(null);
    }
  };

  const pinConfiguration = useSelector((state) => state.login.pinConfiguration);

  console.log(agent)

  async function handleReverse(pin, referenceID, transType, transID, reason) {
    const response = await ReverseTransaction(referenceID, transType, transID, reason, pin, agent['User'].id);
    if (response.callStatus === 1) {
      setAlert({
        showAlert: true,
        message: `${response.msg}`,
        severity: "success",
        header: "Success",
      });
      if (pinConfiguration === "once") {
        sessionStorage.setItem("pin", pin);
      }

    } else {
      setAlert({
        showAlert: true,
        message: `${response.payload.msg}`,
        severity: "error",
        header: "Error",
      });
    }
  }

  const confirmReverse = (referenceID, transType, transID, reversalType, rowData) => {
    console.log("referenceID-----------",referenceID);
    console.log("transType-----------",transType);
    console.log("transID-----------",transID);
    console.log("transID-----------",reversalType);
    console.log("rowData-----------",rowData);
    const newReverseParams = { referenceID, transType, transID };
    setReverseParams(newReverseParams);
    
    setShowInputAlert((prevState) => ({
      ...prevState,
      showAlert: true,
      severity: "confirm",
      message: `Are you sure you want to reverse this transaction? \n Ref No.: ${rowData?.referenceTXID} \n Amount: ${rowData?.amount}`,
      header: "Confirm Reversal",
      alertType: "confirm",
      inputLabel: "Reason",
      onConfirm: (reason) => {
        initiateReverse(reason);
      },
    }));
  };

  const initiateReverse = (reason) => {
    const newReverseParams = { ...reverseParams, reason };
    console.log("newReverseParams==============",newReverseParams);

    // const newReverseParams = { referenceID, transType, transID, reason };
    console.log(type)
    setReverseParams(newReverseParams);
    if (!pin) {
      setShowPinPad(true);
    } else {
      if (type === "voucherHistory") {
        voucherReverse(pin, newReverseParams.referenceID, newReverseParams.transType, newReverseParams.transID, newReverseParams.reason);
      }
      else {
        handleReverse(pin, newReverseParams.referenceID, newReverseParams.transType, newReverseParams.transID, newReverseParams.reason);
      }
    }
  };

  const handleCancelConfirmation = (referenceID, transType, transID, reason) => {
    console.log("handleCancelConfirmation1--------",referenceID);
    console.log("handleCancelConfirmation1--------",transType);
    console.log("handleCancelConfirmation1--------",transID);
    console.log("handleCancelConfirmation1--------",reason);
    const newReverseParams = { referenceID, transType, transID, reason };
    console.log(type)
    setReverseParams(newReverseParams);
    if (!pin) {
      setShowPinPad(true);
    } else {
      if (type === "voucherHistory") {
        voucherReverse(pin, newReverseParams.referenceID, newReverseParams.transType, newReverseParams.transID, newReverseParams.reason);
      }
      else {
        handleReverse(pin, newReverseParams.referenceID, newReverseParams.transType, newReverseParams.transID, newReverseParams.reason);
      }
    }
  }

  const initiateReverseOld = (referenceID, transType, transID, reason) => {
    console.log("selectedExternalAccount--------",selectedExternalAccount);
    // Check if its a master card voucher
    if (selectedExternalAccount && selectedExternalAccount.endsWith("-313")) {
      setConfirmAlert(true)
      setConfirmAlert({
        ...alert,
        showAlert: true,
        message: "By proceeding, you acknowledge that cancelling a 0100 Pre-Authorization voucher may result in an overdraft if a 0220 Completion is received from Bevertec Mastercard and sufficient funds are not available.",
        severity: "confirm",
        header: "Please Confirm",
        alertType: 'confirm',
        onConfirm: () => handleCancelConfirmation(referenceID, transType, transID, reason)
      })
      console.log("MasterCard Voucher");
      return; // optionally stop further execution
    }
    const newReverseParams = { referenceID, transType, transID, reason };
    console.log(type)
    setReverseParams(newReverseParams);
    if (!pin) {
      setShowPinPad(true);
    } else {
      if (type === "voucherHistory") {
        voucherReverse(pin, newReverseParams.referenceID, newReverseParams.transType, newReverseParams.transID, newReverseParams.reason);
      }
      else {
        handleReverse(pin, newReverseParams.referenceID, newReverseParams.transType, newReverseParams.transID, newReverseParams.reason);
      }
    }
  };

  const voucherReverse = async (pin, referenceID, transType, transID, reason) => {
    try {
      console.log("selectedExternalAccount---------",selectedExternalAccount);
      const response = await ReverseVoucher(selectedUser['User'].id, pin, transID, referenceID, agent['User'].id);
      let parsedData;

      console.log(response)
      if (typeof response === "object") {
        parsedData = response;
      } else {
        throw new Error("Unexpected response format.");
      }
  
      console.log("Parsed Data:", parsedData);
  
      if (parsedData?.payload?.header?.callStatus === "1") {
        setAlert({
          showAlert: true,
          message: "Voucher cancelled successfully",
          severity: "success",
          header: "Success",
        });
  
        if (pinConfiguration === "once") {
          sessionStorage.setItem("pin", pin);
        }
      } else {
        setAlert({
          showAlert: true,
          message: parsedData.payload?.msg || "An error occurred. Please try again.",
          severity: "error",
          header: "Error",
        });
      }
    } catch (error) {
      console.error("Error in voucherReverse:", error.message);
      setAlert({
        showAlert: true,
        message: "Failed to process the voucher. Please contact support.",
        severity: "error",
        header: "Error",
      });
    }
  };
  

  console.log(tableData)

  const handleReceipt = (transID) => {
  // Find the transaction in tableData
  const transaction = tableData?.find(item => {
    return item.Vtranshistorybyuser2?.transID == transID ||
           item.Vtranshistorybyuser2?.referenceTXID == transID ||
           item.Vnodetransferpool?.txid == transID;
  });

  const label = transaction?.Vtranshistorybyuser2?.transtypelabel || 
                transaction?.Vnodetransferpool?.typelabel || '';
  
  const msg = transaction?.Vtranshistorybyuser2?.msg || '';

  const isMoneyGram = /moneygram/i.test(label) || /moneygram/i.test(msg);

  let url = `${configVariables.baseURL}${configVariables.receiptExtension}/mod_genreceipt.php?type=internationaltransfer&id=${transID}`;
  
  if (isMoneyGram) {
    url += "&moneygram=1";
  }

  window.open(url, "_blank");
};

  return (
    <Box sx={{ backgroundColor: "#FFF" }}>
      {loading ? (
          <Box sx={{ textAlign: "center", marginTop: "50px" }}>
            <span className="loader" />
          </Box>
        ) : (
          <TableContainer 
            component={Paper} 
            sx={{ 
              boxShadow: "none", 
              backgroundColor: "white !important", 
              maxHeight: "480px",
              overflowX: "scroll",
              display: "block",
              // scrollbarWidth: "thin",
              "&::-webkit-scrollbar": {
                width: "8px",
                height: "8px", 
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#c1c1c1", 
                borderRadius: "4px",
              },
            }}
          >
            {table && tableData && (
              <DynamicTable
                tableData={tableData}
                tableSource={table}
                page={page}
                handleReverse={type == "transactionHistory" ? confirmReverse : initiateReverseOld}
                // handleReverse={initiateReverse}
                type={type}
                isAdmin={isAdmin}
                // isSuperAdmin={'true'}
                isSuperAdmin={isSuperAdmin}
                isAssociateAdmin={isAssociateAdmin}
                isLoanAdmin={isLoanAdmin}
                handleReceipt={handleReceipt}
              />
            )}
            <Box sx={{ backgroundColor: "white" }}>
              <CustomerTable
                page={page}
                onPageChange={handleChangePage}
                pageNumbers={pageNumbers}
              />
            </Box>
          </TableContainer>
        )}

          <CustomInputAlert
            show={showInputAlert?.showAlert}
            severity={showInputAlert?.severity}
            header={showInputAlert?.header}
            message={showInputAlert?.message}
            alertType={"confirm"}
            inputLabel={"Reason"}
            confirmButton={(value) => initiateReverse(value)} 
            onClick={() => setShowInputAlert(false)}
          />
      
      <CustomAlert
        severity={alert.severity}
        show={alert.showAlert}
        header={alert.header}
        message={alert.message}
        onClick={() => setAlert({ ...alert, showAlert: false })}
        autoclose={alert.severity === "error" ? false : true}
      />

      <CustomAlert
        severity={confirmAlert.severity}
        show={confirmAlert.showAlert}
        header={confirmAlert.header}
        message={confirmAlert.message}
        onClick={() => {
            setConfirmAlert({ ...confirmAlert, showAlert: false });
        }}
        alertType={confirmAlert.alertType}
        confirmButton={confirmAlert.onConfirm}
        autoclose={confirmAlert.severity === "error" ? false : true}
      />

      {showPinPad && (
        <PinPad show={showPinPad} handleConfirm={handleConfirm} onClick={() => setShowPinPad(false)} />
      )}
    </Box>
  );
}
